import { render } from "./Public.vue?vue&type=template&id=10f07445"
import script from "./Public.vue?vue&type=script&lang=js"
export * from "./Public.vue?vue&type=script&lang=js"

import "./Public.vue?vue&type=style&index=0&id=10f07445&lang=css"
script.render = render

export default script